import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

function Main() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Research"/>
            <section className="project-detail">
                <div className='container'>
                <div className="c-heading">
                        <h1>Research Equipment</h1> <br/>
                    </div>
                    
                        <div className="border">
                            <div className='mt-3 ms-3'>
                                <h4 className='mb-3'>Research Equipment Utilisation </h4>
                                <ul className='myulcustarrow'>
                                    <li> <Link to ={"https://files.iittp.ac.in/pdfs/research/Price_list_for_internal_and_external_users_15_4_2024.xlsx"}>Price list for internal and external users</Link> </li>
                                    <li> <Link to ={"https://files.iittp.ac.in/pdfs/research/Application%20form-External%20users.docx"}>Application form - External users</Link></li>
                                    <li> <Link to ={"https://files.iittp.ac.in/pdfs/research/Application%20form-Internal%20users.docx"}>Application form - Internal users</Link> </li>
                                </ul>
                            </div>
                        </div>    
                </div>
            </section>
        </>
    );
}

export default Main;